import { compareSerializedStates, serializeAllProducts } from '../utils/states';
export class HistoryApi {
    constructor(coreApi) {
        this.historyActionOngoing = false;
        this.historyEnabled = true;
        this.takeSnapshot = (snapshotName) => {
            if (this.history && !this.historyActionOngoing) {
                this.historyActionOngoing = true;
                this.history.takeSnapshot(snapshotName || 'Snapshot');
                return true;
            }
            return false;
        };
        this.discardLatestSnapshot = () => {
            this.history?.discardLatestSnapshot();
        };
        this.historyAction = (fn, sendHistoryEvent = false) => {
            // If historyActionOngoing, just run the function
            if (this.historyActionOngoing)
                return fn();
            if (!this.takeSnapshot()) {
                return fn();
            }
            const before = serializeAllProducts(this.coreApi);
            const res = fn();
            // Defer state comparison to after promise resolves if function returns promise
            Promise.resolve(res).then(() => {
                this.historyActionOngoing = false;
                const after = serializeAllProducts(this.coreApi);
                const diff = compareSerializedStates(before, after);
                const equalStates = diff.changes === 0;
                if (equalStates) {
                    this.discardLatestSnapshot();
                }
                if (sendHistoryEvent) {
                    this.sendHistoryEvent();
                }
            });
            return res;
        };
        this.sendHistoryEvent = () => {
            this.coreApi.emit.onHistory();
        };
        this.coreApi = coreApi;
        this.history = coreApi.core.services.coreModules.history();
    }
    undo() {
        if (this.history && !this.historyActionOngoing) {
            this.historyActionOngoing = true;
            this.history.undo();
            this.sendHistoryEvent();
            this.historyActionOngoing = false;
        }
    }
    redo() {
        if (this.history && !this.historyActionOngoing) {
            this.historyActionOngoing = true;
            this.history.redo();
            this.sendHistoryEvent();
            this.historyActionOngoing = false;
        }
    }
    clear() {
        if (this.history && !this.historyActionOngoing) {
            this.historyActionOngoing = true;
            this.history.clear();
            this.sendHistoryEvent();
            this.historyActionOngoing = false;
        }
    }
    enable() {
        this.historyEnabled = true;
        this.sendHistoryEvent();
    }
    disable() {
        this.historyEnabled = false;
        this.sendHistoryEvent();
    }
    isHistoryActionOngoing() {
        return this.historyActionOngoing;
    }
    canUndo() {
        return this.history && this.historyEnabled ? this.history.canUndo() : false;
    }
    canRedo() {
        return this.history && this.historyEnabled ? this.history.canRedo() : false;
    }
    pause(fn) {
        this.history?.pause();
        fn();
        this.history?.unPause();
    }
}
//# sourceMappingURL=HistoryApi.js.map